document.addEventListener("DOMContentLoaded", function() {
const slides = document.querySelectorAll('.moast-slide video');

function updateSlides() {
slides.forEach(slide => slide.pause()); // Pause all videos first

const centerSlide = document.querySelector('.moast-slide.slick-center video');
if(centerSlide) {
centerSlide.play().catch(() => {}); // Play only the centered video
}
}

// Initial run
updateSlides();

// Listen for slide changes (Moast uses Slick slider events)
const carousel = document.querySelector('.moast-carousel');
if(carousel && typeof jQuery !== "undefined") {
$(carousel).on('afterChange', function() {
updateSlides();
});
}
});
